@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title" [background]="s.background">
    <div class="faq-list">
      <mat-accordion displayMode="flat" [multi]="false">
        @for (item of s.items; track item.question) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{ item.question }}</mat-panel-title>
            </mat-expansion-panel-header>
            <p class="faq-answer">{{ item.answer }}</p>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </app-section-wrapper>
}
